export enum InputType {
    TEXT = 'text',
    TEXT_AREA = 'textarea',
    NUMBER = 'number',
    CHECK_BOX = 'checkbox',
    RADIO_BUTTON = 'radio',
    SEARCHABLE_SELECT = 'SEARCHABLE_SELECT',
    MULTI_SELECT = 'MULTI_SELECT',
    SELECT = 'SELECT',
    EDITOR = 'EDITOR',
    SWITCH = 'SWITCH',
}

export enum TimeAMPM {
    AM = 'AM',
    PM = 'PM',
}
